import IFormModel from "@/models/IFormModel";
import Model from "@/models/Model";
import {ValidationRule} from "@/declarations/ValidationRule";
import AttachmentRules from "@/models/attachment/AttachmentRules";

export default class AvatarCreate implements IFormModel {

	public model: Model | null = null;
	public file: File | null = null;

	public reset(): void {
		this.model = null;
		this.file = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'file':
				return AttachmentRules.fileRules;
			default:
				return [];
		}
	}

}
